import React, { memo } from 'react'
import { ILoadBoardPost } from 'types/loadBoardPosts'
import { capitalize } from 'utils/capitalize'
import formatCurrency from 'utils/formatCurrency'

interface IPostListEntryProps {
  post: ILoadBoardPost
}

export const PostListEntry = memo<IPostListEntryProps>(({ post }) => {
  const {
    commentsOne,
    commentsTwo,
    destination: { city: destinationCity, stateCode: destinationStateCode },
    equipmentType,
    id,
    includeListRate,
    origin: { city: originCity, stateCode: originStateCode },
    pickupDate,
    postersReferenceId,
    rate,
  } = post
  const formattedRate = rate && includeListRate ? formatCurrency(rate) : 'No Rate'
  const referenceString = `Ref ID #${postersReferenceId}`
  const secondaryString = [formattedRate, pickupDate, equipmentType, referenceString]
    .filter(v => v)
    .join(' · ')
  return (
    <div key={id}>
      <strong data-test='origin-destination-text'>
        {capitalize(originCity)}, {originStateCode} - {capitalize(destinationCity)},{' '}
        {destinationStateCode}
      </strong>
      <div data-test='post-info-text'>{secondaryString}</div>
      <div className='text-caption-semibold mt2'>Comments 1</div>
      <div className='mt1'>
        {commentsOne ?? <div className='text-secondary'> No Comments </div>}
      </div>
      <div className='text-caption-semibold mt2'>Comments 2</div>
      <div className='mt1'>
        {commentsTwo ?? <div className='text-secondary'> No Comments </div>}
      </div>
    </div>
  )
})
